import React from 'react';
import styled from 'styled-components';
import SettingsButton from './SettingsButton';
import media from '../style/media';
import { theme } from '../style/theme';
import { Flex } from './shared/Flex';

const Wrapper = styled(Flex)`
  width: 100%;
  position: relative;
  justify-content: start;
  align-items: center;
  min-height: 70px;
  z-index: ${theme.zIndex.sticky};
  background: ${theme.colors.primary.main};
  backdrop-filter: blur(20px);
  box-shadow: ${theme.shadows.lg};
  transition: all ${theme.transitions.normal};
  
  ${media.tablet`
    padding-left: ${theme.spacing[20]};
    min-height: 80px;
  `}
  
  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: ${theme.colors.secondary.main};
    opacity: 0.8;
  }
`;

const TitleText = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${theme.colors.neutral.white};
  margin-left: ${theme.spacing[20]};
`;

const TopBar = ({ onSettingsClick, isMeasuring }) => {
  return (
    <Wrapper>
      <SettingsButton disable={isMeasuring} onClick={onSettingsClick} />
      <TitleText>Face Scan</TitleText>
    </Wrapper>
  );
};

export default TopBar;
